// Import the RTK Query methods from the React-specific entry point
import { Availability, GetBrandsResponse } from '@/types';
import { GetBrandsByL1sResponse } from '@/types/api/getBrandsByL1s';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define our single API slice object
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('Accept', 'application/json');
      headers.set('Platform', 'website');
      return headers;
    },
  }),
  endpoints: builder => ({
    getBrandsByL1s: builder.query<GetBrandsByL1sResponse, void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const availabilitySlice = (_queryApi.getState() as { availability: Availability }).availability;
        let pincode = availabilitySlice?.pincode;

        if (!pincode) {
          // Wait for 1000ms to see if pincode becomes available
          await new Promise(resolve => setTimeout(resolve, 1000));
          pincode = (_queryApi.getState() as { availability: Availability }).availability?.pincode;
        }

        // Call the API with or without pincode
        const result = await fetchWithBQ({
          url: '/others/getBrandsByL1s',
          params: pincode ? { pincode } : undefined,
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as GetBrandsByL1sResponse };
      },
    }),
    getBrands: builder.query<GetBrandsResponse, void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const availabilitySlice = (_queryApi.getState() as { availability: Availability }).availability;
        let pincode = availabilitySlice?.pincode;

        if (!pincode) {
          // Wait for 1000ms to see if pincode becomes available
          await new Promise(resolve => setTimeout(resolve, 1000));
          pincode = (_queryApi.getState() as { availability: Availability }).availability?.pincode;
        }

        // Call the API with or without pincode
        const result = await fetchWithBQ({
          url: '/others/brands',
          params: pincode ? { pincode } : undefined,
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as GetBrandsResponse };
      },
    }),
  }),
});

// Export the auto-generated hook for the `getBrandsByL1s` query endpoint
export const { useGetBrandsByL1sQuery, useGetBrandsQuery } = apiSlice